import type { ReactNode } from "react";

type WorkspaceShellProps = {
  list: ReactNode;
  details: ReactNode;
  className?: string;
};

export function WorkspaceShell({
  list,
  details,
  className = "",
}: WorkspaceShellProps) {
  return (
    <div
      className={[
        "grid min-h-[42rem] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm",
        "xl:grid-cols-[22rem_minmax(0,1fr)]",
        className,
      ].join(" ")}
    >
      <aside className="border-b border-slate-200 bg-slate-50/70 xl:border-b-0 xl:border-r">
        {list}
      </aside>

      <section className="min-w-0 bg-white">
        {details}
      </section>
    </div>
  );
}